export class ErroValidacaoRegraDeNotificacao extends Error {
  constructor (mensagem: string) {
    super(mensagem)
    this.name = 'ErroValidacaoRegraDeNotificacao'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
